var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":"","aria-label":_vm.sichtbar ? 'Passwort verbergen' : 'Passwort anzeigen',"aria-pressed":_vm.sichtbar ? 'true' : 'false',"data-cy":"passwortAuge"},on:{"click":function($event){return _vm.$emit('umschalten')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.sichtbar ? "mdi-eye" : "mdi-eye-off"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }